import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { FunctionComponent, useState } from 'react';
import { Note } from '../types/note';

export const NoteForm: FunctionComponent<{
  initialData: Note;
  title: string;
  onSaveClick: (note: Note) => void;
  closeDialog: () => void;
}> = ({ initialData, title: operation, onSaveClick, closeDialog }) => {
  const [note, setNote] = useState(initialData);

  const inputInvalid = !note.title || !note.body;

  return (
    <>
      <DialogTitle>{operation} Note</DialogTitle>

      <DialogContent>
        <TextField
          label="Title"
          value={note.title}
          onChange={(e) => setNote((n) => ({ ...n, title: e.target.value }))}
          fullWidth
        />

        <br />

        <TextField
          label="Body"
          value={note.body}
          onChange={(e) => setNote((n) => ({ ...n, body: e.target.value }))}
          multiline
          minRows={8}
          fullWidth
        />
      </DialogContent>

      <DialogActions
        sx={{ p: 3, display: 'flex', justifyContent: 'space-between' }}
      >
        <Button color="error" onClick={closeDialog}>
          Cancel
        </Button>
        <Button disabled={inputInvalid} onClick={() => onSaveClick(note)}>
          Save
        </Button>
      </DialogActions>
    </>
  );
};
